<template>
    <div class="blocks-settings">

        <!-- settings group: PARENT BLOCK -->
        <div class="settings-group-title">
            <h6>parent block</h6>
        </div>

        <div class="settings-group-description">
            <p>Styles and dimensions for the parent wrapper element</p>
        </div>

        <!-- settings group: PARENT BLOCK -->
        <div class="settings-group-title">
            <h6>styles</h6>
        </div>

        <div v-show="deviceStylesSetttings.desktopStyles">

            <!-- background type selection -->
            <div class="setting" v-if="clientPro=='PRO'">
                <!-- <b-form-group label="Use background"> -->
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.backgroundColor"  @change="useBackgroundColor()">
                    Use background color
                </b-form-checkbox>
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.backgroundImage" @change="useBackgroundImage()">
                    Use background image
                </b-form-checkbox>
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.backgroundVideo" @change="useBackgroundVideo()">
                    Use background video (Vimeo or Youtube)
                </b-form-checkbox>
            </div>

            <!-- background type selection free -->
            <div class="setting pro-setting" v-if="clientPro!=='PRO'" v-b-tooltip.hover.top title="PRO feature" v-b-modal="'upgrades-modal'">
                <!-- <b-form-group label="Use background"> -->
                <b-form-checkbox switch>
                    Use background color
                </b-form-checkbox>
                <b-form-checkbox switch>
                    Use background image
                </b-form-checkbox>
                <b-form-checkbox switch>
                    Use background video (Vimeo or Youtube)
                </b-form-checkbox>
            </div>

            <div style="background:#d8dde5;padding:10px;font-size: 12px;border-radius:.25rem;margin-bottom:15px;" v-if="settingsFromWeebly.settings.backgroundVideo">
                <em>Video background will be visible in Weebly editor and on your live site.</em>
            </div>

            <!-- parent color background -->
            <div class="setting" v-if="settingsFromWeebly.settings.backgroundColor">
                <Mycolorpicker elementRef="parentBackground" theColorPicker="allpickers" colorPickerName="Background color parent block:" />
            </div>

            <!-- background image parent -->
            <div v-if="settingsFromWeebly.settings.backgroundImage">

                <!-- upload bg -->
                <div class="setting">
                    <label>Upload background image:</label>
                    <b-form-file name="image_field" @change="onFileSelected()" accept="image/*" />
                </div>

                <!-- background position axis -->
                <div class="setting">
                    <b-form-group>

                        <label>Image position x axis:</label>
                        <b-form-select v-model="settingsFromWeebly.settings.xAxisPosition" size="sm">
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </b-form-select>

                    </b-form-group>
                </div>

                <!-- background position y axis -->
                <div class="setting">
                    <b-form-group>

                        <label>Image position y axis:</label>
                        <b-form-select v-model="settingsFromWeebly.settings.yAxisPosition" size="sm">
                            <option value="top">Top</option>
                            <option value="center">Center</option>
                            <option value="bottom">Bottom</option>
                        </b-form-select>

                    </b-form-group>
                </div>

                <!-- parallax toggle -->
                <div class="setting">
                    <b-form-checkbox switch v-model="settingsFromWeebly.settings.useParallax" @change="activateParallaxToggle">
                        Use true parallax
                    </b-form-checkbox>
                </div>

                <!-- parallax speed -->
                <div class="setting" v-if="settingsFromWeebly.settings.useParallax">
                    <b-form-group>

                        <label for="flexchild-parallaxspeed-input">Parallax speed: <span v-b-tooltip.hover.top title="set value between '-1.0' and '2.0'"><i class="far fa-question-circle"></i></span></label>
                        
                        <b-input-group size="sm">
                            <b-form-input id="flexchild-parallaxspeed-input" type="number" v-model="settingsFromWeebly.settings.parallaxSpeed" min="-1.0" max="2.0" step="0.1" @change="activateParallaxToggle" />
                        </b-input-group>

                    </b-form-group>
                </div>   


            </div>

            <!-- background video parent -->
            <div v-if="settingsFromWeebly.settings.backgroundVideo">
                <div class="setting">
                    <label for="backgroundVideo">Video url (Youtube or Vimeo)</label>
                    <b-form-input id="backgroundVideo" type="text" v-model="settingsFromWeebly.settings.backgroundVideoUrl" @change="activateParallax" size="sm" />
                </div>
                
                <!-- parallax speed -->
                <div class="setting" v-if="settingsFromWeebly.settings.useParallax">
                    <b-form-group>

                        <label for="flexchild-parallaxspeed-input">Parallax speed: <span v-b-tooltip.hover.top title="set value to '1' to deactivate parallax on video"><i class="far fa-question-circle"></i></span></label> 
                        
                        <b-input-group size="sm">
                            <b-form-input id="flexchild-parallaxspeed-input" type="number" v-model="settingsFromWeebly.settings.parallaxSpeed" min="-1.0" max="2.0" step="0.1" @change="activateParallaxToggle" />
                        </b-input-group>

                    </b-form-group>
                </div>  

                <!-- start video time -->
                <div class="setting">
                    <b-form-group>

                        <label for="flexchild-starttime-input">Start time in seconds: <span v-b-tooltip.hover.top title="Start time in seconds when video will be started (this value will be applied also after loop)."><i class="far fa-question-circle"></i></span></label> 
                        
                        <b-input-group size="sm">
                            <b-form-input id="flexchild-starttime-input" type="number" v-model="settingsFromWeebly.settings.parentVideoStartTime" min="0"  step="1" @change="activateParallaxToggle" />
                        </b-input-group>

                    </b-form-group>
                </div>  

            </div>

            <!-- use border parent -->
            <div class="setting">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.useBorderParent" name="parent-use-border">
                    Apply border
                </b-form-checkbox>
            </div>

            <!-- if border selected -->
            <div v-if="settingsFromWeebly.settings.useBorderParent">
                <!-- checkbox for individual border -->
                <!-- <div class="setting">
                    <b-form-checkbox switch v-model="settingsFromWeebly.settings.useIndividualBorder" name="individual-border">
                        Individual border
                    </b-form-checkbox>
                </div>  -->
                
                <div v-if="!settingsFromWeebly.settings.useIndividualBorder">

                    <div class="border-group">

                        <div class="border-group--title">
                            Border desktop
                        </div>
                        <i class="fas unlink-border-radius fa-link" @click="settingsFromWeebly.settings.useIndividualBorder = !settingsFromWeebly.settings.useIndividualBorder" v-b-tooltip.hover.top title="Set borders individually"></i>

                        <!--  general border width DESKTOP -->
                        <div class="setting">
                            <b-form-group>

                                <label for="flexparent-generalborderwidth-input">Width:</label>
                                
                                <b-input-group append="px" size="sm">
                                    <b-form-input id="flexparent-generalborderwidth-input" type="number" v-model="settingsFromWeebly.settings.parentBorderWidth" min="0" />
                                </b-input-group>

                            </b-form-group>
                        </div>   

                        <!--  general border color -->
                        <div class="setting">
                            <Mycolorpicker elementRef="parentBorderColor" theColorPicker="allpickers" colorPickerName="Color:" />
                        </div>

                        <!-- border type general -->
                        <div class="setting">
                            <b-form-group label="Style:">

                                <b-form-select v-model="settingsFromWeebly.settings.parentBorderType" size="sm">

                                    <option value="solid">Solid</option>

                                    <option value="dotted">Dotted</option>

                                    <option value="dashed">Dashed</option>

                                    <option value="double">Double</option>

                                </b-form-select>

                            </b-form-group>
                        </div>

                    </div><!-- border-group -->
                    
                </div><!-- v-if="!parent.useIndividualBorder" -->

                <div v-if="settingsFromWeebly.settings.useIndividualBorder">
                    
                    <!-- border colors and width and type -->
                    <div class="border-group">

                        <div class="border-group--title">
                            Border top desktop
                        </div>
                        <i class="fas unlink-border-radius fa-unlink" @click="settingsFromWeebly.settings.useIndividualBorder = !settingsFromWeebly.settings.useIndividualBorder" v-b-tooltip.hover.top title="Set borders equally"></i>
                    
                        <!--  border top width DESKTOP -->
                        <div class="setting">
                            <b-form-group>

                                <label for="flexparent-generalborderwidth-input">Border top width desktop:</label>
                                
                                <b-input-group append="px" size="sm">
                                    <b-form-input id="flexparent-generalborderwidth-input" type="number" v-model="settingsFromWeebly.settings.borderTopWidthParent" min="0" />
                                </b-input-group>

                            </b-form-group>
                        </div>   

                        <!--  border top color -->
                        <div class="setting">
                            <Mycolorpicker elementRef="borderTopColorParent" theColorPicker="allpickers" colorPickerName="Border top color:" />
                        </div>

                        <!-- border top type -->
                        <div class="setting">
                            <b-form-group label="Border top style:">

                                <b-form-select v-model="settingsFromWeebly.settings.borderTopStyleParent" size="sm">

                                    <option value="solid">solid</option>

                                    <option value="dotted">dotted</option>

                                    <option value="dashed">dashed</option>

                                    <option value="double">double</option>

                                </b-form-select>

                            </b-form-group>
                        </div>

                    </div><!-- border-group -->

                    <!-- border radius individual -->
                    <div class="border-group">

                        <div class="border-group--title">
                            Border right desktop
                        </div>

                        <!--  border right width DESKTOP -->
                        <div class="setting">
                            <b-form-group>

                                <label for="flexparent-borderRightWidthDesk-input">Width:</label>
                                
                                <b-input-group append="px" size="sm">
                                    <b-form-input id="flexparent-borderRightWidthDesk-input" type="number" v-model="settingsFromWeebly.settings.borderRightWidthParent" min="0" />
                                </b-input-group>

                            </b-form-group>
                        </div>   

                        <!--  border right color -->
                        <div class="setting">
                            <Mycolorpicker elementRef="borderRightColorParent" theColorPicker="allpickers" colorPickerName="Color:" />
                        </div>

                        <!-- border right type -->
                        <div class="setting">
                            <b-form-group label="Style:">

                                <b-form-select v-model="settingsFromWeebly.settings.borderRightStyleParent" size="sm">

                                    <option value="solid">solid</option>

                                    <option value="dotted">dotted</option>

                                    <option value="dashed">dashed</option>

                                    <option value="double">double</option>

                                </b-form-select>

                            </b-form-group>
                        </div>
                    
                    </div><!-- border-group -->

                    <div class="border-group">

                        <div class="border-group--title">
                            Border bottom desktop
                        </div>
                        <!--  border bottom width DESKTOP -->
                        <div class="setting">
                            <b-form-group>

                                <label for="flexparent-borderBottomWidth-input">Width:</label>
                                
                                <b-input-group append="px" size="sm">
                                    <b-form-input id="flexparent-borderBottomWidth-input" type="number" v-model="settingsFromWeebly.settings.borderBottomWidthParent" min="0" />
                                </b-input-group>

                            </b-form-group>
                        </div>   

                        <!--  border bottom color -->
                        <div class="setting">
                            <Mycolorpicker elementRef="borderBottomColorParent" theColorPicker="allpickers" colorPickerName="Color:" />
                        </div>

                        <!-- border bottom type -->
                        <div class="setting">
                            <b-form-group label="Style:">

                                <b-form-select v-model="settingsFromWeebly.settings.borderBottomStyleParent" size="sm">

                                    <option value="solid">solid</option>

                                    <option value="dotted">dotted</option>

                                    <option value="dashed">dashed</option>

                                    <option value="double">double</option>

                                </b-form-select>

                            </b-form-group>
                        </div>

                    </div><!-- border-group -->

                    <div class="border-group">

                        <div class="border-group--title">
                            Border left desktop
                        </div>
                        
                        <!--  border left width DESKTOP -->
                        <div class="setting">
                            <b-form-group>

                                <label for="flexparent-borderLeftWidth-input">Width:</label>
                                
                                <b-input-group append="px" size="sm">
                                    <b-form-input id="flexparent-borderLeftWidth-input" type="number" v-model="settingsFromWeebly.settings.borderLeftWidthParent" min="0" />
                                </b-input-group>

                            </b-form-group>
                        </div>   

                        <!--  border left color -->
                        <div class="setting">
                            <Mycolorpicker elementRef="borderLeftColorParent" theColorPicker="allpickers" colorPickerName="Color:" />
                        </div>

                        <!-- border left type -->
                        <div class="setting">
                            <b-form-group label="Style:">

                                <b-form-select v-model="settingsFromWeebly.settings.borderLeftStyleParent" size="sm">

                                    <option value="solid">solid</option>

                                    <option value="dotted">dotted</option>

                                    <option value="dashed">dashed</option>

                                    <option value="double">double</option>

                                </b-form-select>

                            </b-form-group>
                        </div>
                    </div><!-- border-group -->

                </div><!-- v-if="parent.useIndividualBorder" -->  

            </div><!-- if border selected -->  
            
            <!-- border radius -->
            <div class="setting">
                <div class="border-group">

                    <div class="border-group--title">
                        Border radius desktop
                    </div>
                    <i class="fas unlink-border-radius fa-link" @click="settingsFromWeebly.settings.useIndividualBorderRadius = !settingsFromWeebly.settings.useIndividualBorderRadius" v-b-tooltip.hover.top title="Set border radius individually"></i>

                    <!--  general border radius DESKTOP -->
                    <div class="setting" v-if="!settingsFromWeebly.settings.useIndividualBorderRadius">
                        <b-form-group>

                            <label for="flexparent-generalborderradius-input">Radius:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-generalborderradius-input" type="number" v-model="settingsFromWeebly.settings.borderRadiusGeneral" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>

                    <!--  general border radius top left DESKTOP -->
                    <div class="setting" v-if="settingsFromWeebly.settings.useIndividualBorderRadius">
                        <b-form-group>

                            <label for="flexparent-borderradiuslefttop-input">Top left:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderradiuslefttop-input" type="number" v-model="settingsFromWeebly.settings.borderTopLeftRadius" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>  

                    <!--  general border radius top right DESKTOP -->
                    <div class="setting" v-if="settingsFromWeebly.settings.useIndividualBorderRadius">
                        <b-form-group>

                            <label for="flexparent-borderradiusrighttop-input">Top right:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderradiusrighttop-input" type="number" v-model="settingsFromWeebly.settings.borderTopRightRadius" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>  

                    <!--  general border radius top left DESKTOP -->
                    <div class="setting" v-if="settingsFromWeebly.settings.useIndividualBorderRadius">
                        <b-form-group>

                            <label for="flexparent-borderradiusbottomright-input">Bottom right:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderradiusbottomright-input" type="number" v-model="settingsFromWeebly.settings.borderBottomRightRadius" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>  

                    <!--  general border radius top left DESKTOP -->
                    <div class="setting" v-if="settingsFromWeebly.settings.useIndividualBorderRadius">
                        <b-form-group>

                            <label for="flexparent-borderradiusbottomleft-input">Bottom left:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderradiusbottomleft-input" type="number" v-model="settingsFromWeebly.settings.borderBottomLeftRadius" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>   

                </div><!-- border-group -->
            </div>
        
        </div><!-- if desktop settings -->

        <div v-show="deviceStylesSetttings.tabletStyles">

            <!-- horizontal padding  TABLET -->
            <div class="setting">
                <b-form-group>

                    <label for="flexparent-horizontalpadding-input">Horizontal padding tablet:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-horizontalpadding-input" type="number" v-model="settingsFromWeebly.settings.horizontalPadTabletParent" min="0" />
                    </b-input-group>

                </b-form-group>
            </div>    

            <!-- vertical padding  TABLET -->
            <div class="setting">
                <b-form-group>

                    <label for="flexparent-verticalpadding-input">Vertical padding tablet:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-verticalpadding-input" type="number" v-model="settingsFromWeebly.settings.verticalPadTabletParent" min="0" />
                    </b-input-group>

                </b-form-group>
            </div>

            <div v-if="!settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent">

                <div class="border-group">

                    <div class="border-group--title">
                        Border tablet
                    </div>
                    <!--  general border width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-generalborderwidthtablet-input">Width:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-generalborderwidthtablet-input" type="number" v-model="settingsFromWeebly.settings.borderGeneralWidthTabletParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div> 
                </div><!-- border group -->

            </div><!-- v-if="!parent.useIndividualBorder" -->

            <div v-if="settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent">
                
                <div class="border-group">

                    <div class="border-group--title">
                        Border tablet
                    </div>

                    <!--  border top width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-generalbordertopwidthtablet-input">Width border top:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-generalbordertopwidthtablet-input" type="number" v-model="settingsFromWeebly.settings.borderTopWidthTabletParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>   

                    <!--  border right width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-borderRightWidthTablet-input">Width border right:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderRightWidthTablet-input" type="number" v-model="settingsFromWeebly.settings.borderRightWidthTabletParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>   

                    <!--  border bottom width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-borderBottomWidthTablet-input">Width border bottom:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderBottomWidthTablet-input" type="number" v-model="settingsFromWeebly.settings.borderBottomWidthTabletParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>   

                    <!--  border left width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-borderLeftWidthTablet-input">Width border left:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderLeftWidthTablet-input" type="number" v-model="settingsFromWeebly.settings.borderLeftWidthTabletParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>  

                </div><!-- border group --> 

            </div><!-- v-if="parent.useIndividualBorder" -->

        </div><!-- tabletSettings -->

        <div v-show="deviceStylesSetttings.mobileStyles">

            <!-- horizontal padding PHONE  -->
            <div class="setting">
                <b-form-group>

                    <label for="flexparent-horizontalpadding-input">Horizontal padding phone:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-horizontalpadding-phone-input" type="number" v-model="settingsFromWeebly.settings.horizontalPadPhoneParent" min="0" />
                    </b-input-group>

                </b-form-group>
            </div>    

            <!-- vertical padding  PHONE -->
            <div class="setting">
                <b-form-group>

                    <label for="flexparent-verticalpadding-input">Vertical padding phone:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-verticalpadding-input" type="number" v-model="settingsFromWeebly.settings.verticalPadPhoneParent" min="0" />
                    </b-input-group>

                </b-form-group>
            </div>

            <div v-if="!settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent">

                <div class="border-group">

                    <div class="border-group--title">
                        Border phone
                    </div>
                    <!--  general border width PHONE -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-generalborderwidthphone-input">Width:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-generalborderwidthphone-input" type="number" v-model="settingsFromWeebly.settings.borderGeneralWidthPhoneParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div> 
                </div><!-- border group -->

            </div><!-- v-if="!parent.useIndividualBorder" -->

            <div v-if="settingsFromWeebly.settings.useIndividualBorder && settingsFromWeebly.settings.useBorderParent">
                
                <div class="border-group">

                    <div class="border-group--title">
                        Border phone
                    </div>

                    <!--  border top width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-generalbordertopwidthphone-input">Width border top:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-generalbordertopwidthphone-input" type="number" v-model="settingsFromWeebly.settings.borderTopWidthPhoneParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>   

                    <!--  border right width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-borderRightWidthPhone-input">Width border right:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderRightWidthPhone-input" type="number" v-model="settingsFromWeebly.settings.borderRightWidthPhoneParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>   

                    <!--  border bottom width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-borderBottomWidthPhone-input">Width border bottom:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderBottomWidthPhone-input" type="number" v-model="settingsFromWeebly.settings.borderBottomWidthPhoneParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>   

                    <!--  border left width TABLET -->
                    <div class="setting">
                        <b-form-group>

                            <label for="flexparent-borderLeftWidthPhone-input">Width border left:</label>
                            
                            <b-input-group append="px" size="sm">
                                <b-form-input id="flexparent-borderLeftWidthPhone-input" type="number" v-model="settingsFromWeebly.settings.borderLeftWidthPhoneParent" min="0" />
                            </b-input-group>

                        </b-form-group>
                    </div>  

                </div><!-- border group --> 

            </div><!-- v-if="parent.useIndividualBorder" -->

        </div><!-- tabletSettings -->

        <!-- settings group: PARENT BLOCK -->
        <div class="settings-group-title">
            <h6>dimensions</h6>
        </div>
        
        <div v-show="deviceStylesSetttings.desktopStyles">

            <!-- checkbox set full width -->
            <div class="setting">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.parentFullWidth" name="parent-full-width" @change="activateParallax">
                    Set parent to full width
                </b-form-checkbox>
            </div>

            <!-- max width parent inner wrap -->
            <div class="setting" v-if="settingsFromWeebly.settings.parentFullWidth">
                <b-form-group>

                    <label for="flexparent-maxwidth-input">Max width inner content wrap:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-maxwidthinnercontent-input" type="number" v-model="settingsFromWeebly.settings.parentMaxWidth" min="100" />
                    </b-input-group>

                </b-form-group>
            </div> 

            <!-- max width parent -->
            <div class="setting" v-if="!settingsFromWeebly.settings.parentFullWidth">
                <b-form-group>

                    <label for="flexparent-maxwidth-input">Max width:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-maxwidth-input" type="number" v-model="settingsFromWeebly.settings.parentMaxWidth" min="100" />
                    </b-input-group>

                </b-form-group>
            </div>   

            <!-- vertical padding parent -->
            <div class="setting">
                <b-form-group>

                    <label for="flexparent-horizontalpadding-input">Horizontal padding parent:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-horizontalpadding-input" type="number" v-model="settingsFromWeebly.settings.parentHorizontalPadding" min="0" />
                    </b-input-group>

                </b-form-group>
            </div>      

            <!-- horizontal padding parent -->
            <div class="setting">
                <b-form-group>

                    <label for="flexparent-verticalpadding-input">Vertical padding parent:</label>
                    
                    <b-input-group append="px" size="sm">
                        <b-form-input id="flexparent-verticalpadding-input" type="number" v-model="settingsFromWeebly.settings.parentVerticalPadding" min="0" />
                    </b-input-group>

                </b-form-group>
            </div>

        </div>

    </div>
</template>

<script>

import Mycolorpicker from './Mycolorpicker'
import Mycolorpickerchildblocks from './Mycolorpickerchildblocks'

import axios from 'axios'

export default {

    name: 'BlocksSettings',

    data() {
        return {
            colors: '#fff',
            indexId: 1,
            // desktopSettings: true,
            // tabletSettings: false,
            // mobileSettings: false,

            selectedFile : ''
        }
    },

    computed:{
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },
        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        },

        clientPro() {
            return this.$store.state.clientInfo.clientAccount
        }
    },

    mounted() {
        setTimeout(()=>{
            if(document.querySelector('.jarallax')){
                jarallax(document.querySelectorAll('.jarallax'))
                console.log('activate jarallax on load element')
            }
        },1000)
    },

    components: {
        // color picker
        Mycolorpicker,
        Mycolorpickerchildblocks
    },

    methods: {
        activateParallaxToggle() {
            // if(event.target.checked === true) {
                this.activateParallax()
            // }
        },

        activateParallax() {

            if(document.querySelector('.jarallax')){
                jarallax(document.querySelectorAll('.jarallax'), 'destroy');
            }

            setTimeout(()=>{
                if(document.querySelector('.jarallax')){
                    jarallax(document.querySelectorAll('.jarallax'))
                }
            },1000)
            console.log('we will need to revise reload of video here')
                
        },

        onFileSelected(index) {

            this.selectedFile = event.target.files[0]

            let fd = new FormData();
            fd.append('image', this.selectedFile)
            axios.post('/weebly/app_in_process/buttons/imageUpload.php', fd, {
                // headers: {
                //     'Content-Type': 'multipart/form-data'
                // }
            })
            .then(res => {
                console.log(res)
                // this.imageBg = 'https://appjustable.com/weebly/app_in_process/buttons/'+res.data

                this.$store.state.weeblySettings.settings.backgroundImageSet = 'https://appjustable.com/weebly/app_in_process/buttons/'+res.data

            }).catch( error => {
                console.log(error);
            })

            // check if parallax was activated and if so, do run it on this element
            if(this.$store.state.weeblySettings.settings.useParallax === true){
                this.activateParallax()
            }

        },

        useBackgroundColor(index) {
            if(event.target.checked === true) {
                this.$store.state.weeblySettings.settings.backgroundColor = true
                this.$store.state.weeblySettings.settings.backgroundImage = false
                this.$store.state.weeblySettings.settings.backgroundVideo = false
                this.$store.state.weeblySettings.settings.useParallax = false
                this.activateParallax()
            } else {
                this.$store.state.weeblySettings.settings.backgroundColor = false
                this.$store.state.weeblySettings.settings.backgroundImage = true
                this.$store.state.weeblySettings.settings.backgroundVideo = false
                this.$store.state.weeblySettings.settings.useParallax = false
            }
            
        },

        useBackgroundImage(index) {
            if(event.target.checked === true) {
                this.$store.state.weeblySettings.settings.backgroundColor = false
                this.$store.state.weeblySettings.settings.backgroundImage = true
                this.$store.state.weeblySettings.settings.backgroundVideo = false
                this.$store.state.weeblySettings.settings.useParallax = false
                this.activateParallax()
            } else {
                this.$store.state.weeblySettings.settings.backgroundColor = true
                this.$store.state.weeblySettings.settings.backgroundImage = false
                this.$store.state.weeblySettings.settings.backgroundVideo = false
                this.$store.state.weeblySettings.settings.useParallax = false
            }
        },

        useBackgroundVideo(index) {
            if(event.target.checked === true) {
                this.$store.state.weeblySettings.settings.useParallax = true
                this.$store.state.weeblySettings.settings.backgroundColor = false
                this.$store.state.weeblySettings.settings.backgroundImage = false
                this.$store.state.weeblySettings.settings.backgroundVideo = true
                this.activateParallax()
            } else {
                this.$store.state.weeblySettings.settings.useParallax = false
                this.$store.state.weeblySettings.settings.backgroundColor = true
                this.$store.state.weeblySettings.settings.backgroundImage = false
                this.$store.state.weeblySettings.settings.backgroundVideo = false
            }
        }

    }
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/BlocksSettings.vue